'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var yup = require('yup');
require('core-js/es6/promise');
require('core-js/es6/set');
var googleLibPhoneNumber = require('google-libphonenumber');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var yup__namespace = /*#__PURE__*/_interopNamespace(yup);
var googleLibPhoneNumber__default = /*#__PURE__*/_interopDefaultLegacy(googleLibPhoneNumber);

var isNotEmpty = function isNotEmpty(value) {
  return yup__namespace.mixed().required().isValid(value);
}; // @ts-expect-error TS(7006): Parameter 'email' implicitly has an 'any' type.

var isEmail = function isEmail(email) {
  return yup__namespace.string().email().isValid(email);
}; // @ts-expect-error TS(7006): Parameter 'number' implicitly has an 'any' type.

var isNumber = function isNumber(number) {
  return yup__namespace.number().isValid(number);
}; // @ts-expect-error TS(7006): Parameter 'length' implicitly has an 'any' type.

var isStringLength = function isStringLength(length, value) {
  return yup__namespace.string().min(length).max(length).isValid(value);
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var isUrl = function isUrl(value) {
  return yup__namespace.string().url().isValid(value);
};
var phoneUtil = googleLibPhoneNumber__default["default"].PhoneNumberUtil.getInstance();
var phoneType = googleLibPhoneNumber__default["default"].PhoneNumberType;
var isMobileNumber = function isMobileNumber(phoneNumber, countryCode) {
  if (!countryCode) {
    throw new Error('`countryCode` not given.');
  }

  if (!phoneNumber) {
    return false;
  }

  try {
    var parsedPhoneNumber = phoneUtil.parse(phoneNumber, countryCode);
    return phoneUtil.getNumberType(parsedPhoneNumber) === phoneType.MOBILE;
  } catch (err) {
    return false;
  }
};
var isLandlineNumber = function isLandlineNumber(landline, countryCode) {
  if (!countryCode) {
    throw new Error('`countryCode` not given.');
  }

  if (!landline) {
    return false;
  }

  try {
    var parsedPhoneNumber = phoneUtil.parse(landline, countryCode);
    var numberType = phoneUtil.getNumberType(parsedPhoneNumber);
    var isLandline = numberType === phoneType.FIXED_LINE || numberType === phoneType.TOLL_FREE || numberType === phoneType.SHARED_COST;
    return isLandline;
  } catch (err) {
    return false;
  }
};
var validate = {
  isEmail: isEmail,
  isNotEmpty: isNotEmpty,
  isNumber: isNumber,
  isStringLength: isStringLength,
  isUrl: isUrl,
  isMobileNumber: isMobileNumber,
  isLandlineNumber: isLandlineNumber
};

exports["default"] = validate;
exports.isEmail = isEmail;
exports.isLandlineNumber = isLandlineNumber;
exports.isMobileNumber = isMobileNumber;
exports.isNotEmpty = isNotEmpty;
exports.isNumber = isNumber;
exports.isStringLength = isStringLength;
exports.isUrl = isUrl;
